<style lang="less">
    .page_con.score{
        width:100vw;
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        .top_con{
            width:100%;
            height:30vh;
            background:url("../assets/images/topbg-chengji.png") no-repeat;
            background-size: 100% 100%;
            text-align: center;
            .score{
                font-size: 1.8rem;
                color:#fff;
                padding-top:2vh;
            }
            .close{
                width:.4rem;
                height:auto;
                position: absolute;
                top:2vh;
                right:4vw;
                z-index: 11;
            }
            .text{
                width:60vw;
                height:.7rem;
                line-height:.6rem;
                font-size: .46rem;
                color:#fff;
                border:.01rem solid #fff;
                border-radius: 10px;
                margin:0 auto;
            }
        }
        .mid_con{
            width:100%;
            flex:1;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background:url("../assets/images/bg3.png") no-repeat;
            background-size: cover;

            .info{
                flex:1;
                // text-align: center;
                .name{
                    font-size: 1rem;
                    line-height: 1;
                    letter-spacing: 5px;
                    margin-bottom: 1vh;
                }
                .school{
                    font-size: .4rem;
                    line-height: 1;
                    letter-spacing: 3px;
                }
            }
            .lv{
                width:25vw;
                height:25vw;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background:url("../assets/images/grade-chengji.png") no-repeat;
                background-size: 100% 100%;
                color:#fff;
                p{
                    font-size: 1rem;
                    line-height: 1;
                }
                span{
                    font-size: .36rem;
                }
            }
        }
        .bottom_con{
            width:100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding-top:2vh;
            .item{
                width:33%;
                height:auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: 3vh;
                img{
                    width:60%;
                    height:auto;
                    display: block;
                    margin-bottom: .1rem;
                }
                span{
                    color:#ea5515;
                    font-size: .34rem;
                }
            }
            .item:nth-child(n+3){
                margin-bottom: 2vh;
            }
        }
        .nocontent{
            p{
                width:70%;
                height:10vh;
                line-height:10vh;
                text-align: center;
                background:#fff;
                border-radius: .2rem;
                color:#333;
                font-size: .48rem;
                letter-spacing: .03rem;
            }
        }
    }
</style>
<template>
    <div class="page_con score">
        <div class="top_con">
            <img class="close" @click="$router.go(-1)" src="../assets/images/closer.png">
            <div class="score">{{$store.getters.userInfo.score}}</div>
            <div class="text">成績</div>
        </div>
        <div class="mid_con">
            <div class="info">
                <p class="name">{{$store.getters.userInfo.Name}}</p>
                <span class="school">{{$store.getters.userInfo.SchoolName}}</span>
            </div>
            <div class="lv">
                <!-- <img src="../assets/images/grade-chengji.png" alt=""> -->
                <p>{{$store.getters.userInfo.lv}}</p>
                <span>等級</span>
            </div>
        </div>
        <div class="bottom_con">
            <div @click="jump(item)" class="item" v-for="(item,index) in menu" :key="index">
                <img :src="item.img" alt="">
                <span>{{item.name}}</span>
            </div>
        </div>
        <div class="nocontent shade" v-if="showNo">
            <p>該功能暫未開放</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            showNo:false,
            showNotimer:null,

            menu:[
                {
                    img:require('../assets/images/longhubang-chengji.png'),
                    url:'/rank',
                    name:'龍虎榜',
                    cango:1,
                },
                {
                    img:require('../assets/images/gerenchengji-chengji.png'),
                    url:'/detail',
                    name:'個人成績',
                    cango:1,
                },
                {
                    img:require('../assets/images/file.png'),
                    url:'/info',
                    name:'學習檔案',
                    cango:1,
                },
                {
                    img:require('../assets/images/again.png'),
                    url:'/redo',
                    name:'補做',
                    cango:1,
                },
                {
                    img:require('../assets/images/home.png'),
                    url:'/index',
                    name:'主頁',
                    cango:1,
                },
                {
                    img:require('../assets/images/Star.png'),
                    url:'/classes',
                    name:'全班表現',
                    cango:1,
                },
            ],
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        jump(item){
            if(!item.cango){
                if(item.url == '/redo'){
                    // return;
                }
                if(item.url == '/info'){
                    // return;
                }
                this.showNoContent();
                return;
            }else{
                this.$router.push(item.url);
            }
        },
        showNoContent(){
            let vm = this;
            this.showNo = true;
            this.showNotimer = setTimeout(()=>{
                vm.showNo = false;
                clearTimeout(vm.showNotimer);
                vm.showNotimer = null;
            },2000);
        },
        getData(){
            let vm = this;
            this.$http.get('/IndexDaily/gameList?rest_key=1').then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setUserInfo',res.data.data.user);
                }
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/score.vue